import logRepository from "../../repositories/log";

class LoggerLibrary {
    static setLog(message) {
        setTimeout(() => {
            logRepository.frontendSet({message: message});
        }, 1000);
    }
}
export default LoggerLibrary;
